const QueryKeys = {
  panel: 'panel',
  usersMe: 'usersMe',
  reports: 'reports',
  filters: 'filters',
  program: 'program',
  effects: 'effects',
  materials: 'materials',
  sceneById: 'sceneById',
  currentIp: 'currentIp',
  blockDetails: 'blockDetails',
  chapterOfDay: 'chapterOfDay',
  chaptersBlock: 'chaptersBlock',
  scenesByChapter: 'scenesByChapter',
  blocksByProgram: 'blocksByProgram',
  charactersByScript: 'charactersByScript',
  chaptersWithScenes: 'chaptersWithScenes',
  scenariosByProgram: 'scenariosByProgram',
  suggestionsEffects: 'suggestionsEffects',
  environmentsByProgram: 'environmentsByProgram',
  generateMaterialWithAI: 'generateMaterialWithAI',
  getSuggestionsMaterial: 'getSuggestionsMaterial',
  sceneDetailsForDecoupage: 'sceneDetailsForDecoupage',
  automaticSuggestionsMaterial: 'automaticSuggestionsMaterial',
} as const;

export { QueryKeys };
